"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_i18next_1 = require("react-i18next");
const material_ui_confirm_1 = require("material-ui-confirm");
const FormControlLabel_1 = __importDefault(require("@mui/material/FormControlLabel"));
const Checkbox_1 = __importDefault(require("@mui/material/Checkbox"));
function default_1({ manageAddressForm, isDefaultCheckDisabled, }) {
    const { register, watch } = manageAddressForm;
    const isDefault = watch('is_default');
    const isChecked = typeof isDefault === 'boolean' ? isDefault : true;
    const confirm = (0, material_ui_confirm_1.useConfirm)();
    const { t } = (0, react_i18next_1.useTranslation)();
    const onDefaultUncheck = (e) => {
        if (!e.target.checked) {
            confirm({
                description: t('기본 배송지를 해제하면 다음 주소가 기본으로 설정됩니다. 원하는 기본 배송지를 설정해 주세요!'),
                cancellationButtonProps: { style: { display: 'none' } },
            });
        }
    };
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ css: { padding: '10px 16px' } }, { children: (0, jsx_runtime_1.jsx)(FormControlLabel_1.default, { disabled: isDefaultCheckDisabled, control: (0, jsx_runtime_1.jsx)(Checkbox_1.default, Object.assign({}, register('is_default', { onChange: onDefaultUncheck }), { checked: isChecked, sx: { p: '8px', m: '-6px' } })), label: (0, jsx_runtime_1.jsx)("div", Object.assign({ className: `body2 ${isDefaultCheckDisabled ? 'gray-40' : 'gray-80'}` }, { children: t('기본 배송지') })), sx: {
                columnGap: '4px',
                m: 0,
            } }) })));
}
exports.default = default_1;
